import React from 'react';
import { useLanguage } from '../../i18n';

const Step4_Details = ({ 
  formData, 
  onInputChange,
  onFormDataChange,
  onBack, 
  onCalculate,
  onLoadInfo,
  loading
}) => {
  const { t } = useLanguage();

  return (
    <div className="step-content" data-testid="step-4">
      <h2 className="step-title">{t('step4Title')}</h2>
      <p className="step-description">{t('step4Desc')}</p>
      <div className="form-group">
        <label className="form-label">{t('timeframeLabel')}</label>
        <select name="timeframe" value={formData.timeframe} onChange={onInputChange} className="form-select" data-testid="timeframe-select">
          <option value="sofort">{t('timeframeSofort')}</option>
          <option value="nach-ruecksprache">{t('timeframeNachRuecksprache')}</option>
          <option value="3-6">{t('timeframe3_6')}</option>
          <option value="6-12">{t('timeframe6_12')}</option>
          <option value=">12">{t('timeframeOver12')}</option>
        </select>
      </div>
      
      <div className="form-group">
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
          <label className="form-label" style={{ marginBottom: 0 }}>{t('subsidyLabel')}</label>
          <button type="button" onClick={onLoadInfo} style={{ background: 'none', border: 'none', color: '#1B5E20', cursor: 'pointer', fontSize: '0.875rem', textDecoration: 'underline', padding: 0, display: 'flex', alignItems: 'center', gap: '0.25rem' }} data-testid="subsidy-info-link">
            {t('moreInfo')}
          </button>
        </div>
        <div className="radio-group">
          <div className="radio-option">
            <input type="radio" name="has_subsidy" value="true" checked={formData.has_subsidy === true} onChange={() => onFormDataChange({ ...formData, has_subsidy: true })} id="subsidy-yes" data-testid="subsidy-yes" />
            <label htmlFor="subsidy-yes" className="radio-label">{t('yes')}</label>
          </div>
          <div className="radio-option">
            <input type="radio" name="has_subsidy" value="false" checked={formData.has_subsidy === false} onChange={() => onFormDataChange({ ...formData, has_subsidy: false, subsidy_amount_erdwaerme: '', subsidy_amount_luftwaerme: '' })} id="subsidy-no" data-testid="subsidy-no" />
            <label htmlFor="subsidy-no" className="radio-label">{t('no')}</label>
          </div>
        </div>
      </div>
      
      {formData.has_subsidy && (
        <>
          <div className="form-group">
            <label className="form-label">{t('subsidyErdwaermeLabel')} ({formData.country === 'CH' ? 'CHF' : 'EUR'})</label>
            <input type="number" name="subsidy_amount_erdwaerme" value={formData.subsidy_amount_erdwaerme} onChange={onInputChange} className="form-input" placeholder={t('subsidyPlaceholder')} min="0" max="200000" data-testid="subsidy-amount-erdwaerme-input" />
          </div>
          <div className="form-group">
            <label className="form-label">{t('subsidyLuftwaermeLabel')} ({formData.country === 'CH' ? 'CHF' : 'EUR'})</label>
            <input type="number" name="subsidy_amount_luftwaerme" value={formData.subsidy_amount_luftwaerme} onChange={onInputChange} className="form-input" placeholder={t('subsidyLuftPlaceholder')} min="0" max="200000" data-testid="subsidy-amount-luftwaerme-input" />
          </div>
        </>
      )}
      
      <div className="button-group">
        <button onClick={onBack} className="btn-secondary" data-testid="step-4-back-btn">{t('back')}</button>
        <button onClick={onCalculate} className="btn-primary" disabled={loading} data-testid="step-4-calculate-btn">
          {loading ? t('calculating') : t('calculateBtn')}
        </button>
      </div>
    </div>
  );
};

export default Step4_Details;
